import { useTheme } from '@mui/material/styles'
import { useEffect, useState, useContext, useRef } from 'react'
import { Stack, Box, Typography, List, ListItem } from '@mui/material'
import { motion } from 'framer-motion'
import { useNavigate, Link } from 'react-router-dom'
import Logo from '../../assets/logo'


export const Standards = ({ }) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <Stack sx={{ width: '100vw', minHeight: '100vh' }} alignItems={'center'}>
            <Stack
                sx={{ width: '100vw', height: 200 }}
                justifyContent={'center'}
                alignItems={'center'}
            >
                <Logo width={200} />
            </Stack>

            <Stack
                direction={'column'}
                sx={{ maxWidth: 600, justifyContent: 'center' }}
                style={{ fontSize: 22, marginBottom: 16 }}
            >
                <motion.div style={{ fontSize: 25, fontWeight: 500, marginBottom: 5 }}>
                    Standards against child sexual abuse and exploitation (CSAE)
                </motion.div>
                <motion.div style={{ fontSize: 16, marginBottom: 5 }}>
                    JoinU for Harvard is exclusively available to the Harvard University community. All members of the Harvard community,  contractors and volunteers who interact with Minors while engaging with JoinU must abide by the <Link className="link" to="https://youthprotection.harvard.edu/guidelines">Harvard University Guidelines for Interacting with Minors</Link>. 
                </motion.div>
                <motion.div style={{ fontSize: 16, marginBottom: 20 }}>
                    JoinU is committed to creating a safe and respectful environment for all users. As part of our mission to prioritize user safety, we strictly prohibit any content or activity that exploits or harms children. This policy outlines our zero-tolerance approach to child sexual abuse and exploitation (CSAE).
                </motion.div>


                <motion.div style={{ fontSize: 20, fontWeight: 500, marginBotom: 10 }}>
                    1. Prohibited Content and Behavior
                </motion.div>
                <motion.div style={{ fontSize: 16, marginBottom: 16 }}>
                    We do not allow:
                    <List
                        sx={{
                            listStyleType: 'disc',
                            pl: 2,
                            '& .MuiListItem-root': {
                                display: 'list-item',
                            },
                        }}
                    >
                        <ListItem>The sharing, storage, or distribution of explicit content involving minors, including images, videos, or text.</ListItem>
                        <ListItem>Grooming or other predatory behaviors aimed at exploiting or endangering children.</ListItem>
                        <ListItem>Any form of communication or activity intended to facilitate the sexual exploitation of minors.</ListItem>
                        <ListItem>Attempts to evade our safety measures to engage in harmful or exploitative behavior.</ListItem>
                    </List>
                </motion.div>

                <motion.div style={{ fontSize: 20, fontWeight: 500, marginBotom: 10 }}>
                    2. Enforcement and Reporting
                </motion.div>
                <motion.div style={{ fontSize: 16, marginBottom: 16 }}>
                    Our team actively monitors for violations of this policy. If prohibited content or behavior is detected, we take immediate action, which may include:

                    <List
                        sx={{
                            listStyleType: 'disc',
                            pl: 2,
                            '& .MuiListItem-root': {
                                display: 'list-item',
                            },
                        }}
                    >
                        <ListItem>Removing offending content.</ListItem>
                        <ListItem>Suspending or banning user accounts involved in violations.</ListItem>
                        <ListItem>Reporting incidents to appropriate law enforcement authorities.</ListItem>
                    </List>

                    We encourage users to report any content or behavior that may violate these standards. Reports can be submitted via our in-app reporting tools or by contacting us directly at admin@joinu.org.
                </motion.div>

                <motion.div style={{ fontSize: 20, fontWeight: 500, marginBotom: 10 }}>
                    3. Collaboration with Authorities
                </motion.div>
                <motion.div style={{ fontSize: 16, marginBottom: 16 }}>
                    We cooperate fully with law enforcement and child protection organizations to prevent, detect, and respond to incidents of CSAE.
                </motion.div>

                <motion.div style={{ fontSize: 20, fontWeight: 500, marginBotom: 10 }}>
                    4. Ongoing Commitment
                </motion.div>
                <motion.div style={{ fontSize: 16, marginBottom: 16 }}>
                    We continuously update our policies, tools, and systems to combat CSAE effectively. Our safety measures include advanced content moderation technologies, regular staff training, and collaboration with industry experts.
                </motion.div>


            </Stack>
        </Stack>
    )
}
